var _g, _path, _path2, _path3, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhone2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 438,
    height: 438,
    viewBox: "0 0 438 438",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3834_20858)"
  }, /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter1_i_3834_20858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.539 250.054L290.172 284.483C294.116 278.493 297.878 272.398 301.458 266.198C312.264 247.271 321.439 228.01 328.983 208.415C336.384 188.859 341.483 169.92 344.032 151.818C346.542 133.572 345.793 116.97 341.785 102.012C339.165 92.2323 334.934 83.3462 329.17 75.6416C323.367 67.7932 315.744 61.2035 306.194 56.0547C294.561 49.4602 283.299 47.6993 272.656 50.5511C268.629 51.6301 264.833 53.5721 261.7 56.2615C258.423 58.9893 255.809 62.4646 254.222 66.8977L233.456 122.869C231.831 127.158 230.848 130.967 230.401 134.478C229.916 137.845 230.006 141.058 230.738 143.791C231.663 147.243 233.595 150.425 236.495 153.193C239.251 156 242.908 158.72 247.285 161.247L261.26 169.68C263.266 170.838 264.486 172.515 265.103 174.816C265.411 175.967 265.537 177.012 265.558 178.24C265.435 179.506 265.234 180.485 265.178 181.425C263.861 186.865 261.059 194.244 256.735 203.418C252.267 212.631 247.406 222.104 241.97 231.73C238.141 238.152 234.417 244.391 230.539 250.054Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M229.039 252.652L226.234 251.032L228.064 248.359C231.873 242.796 235.543 236.651 239.375 230.224C244.764 220.68 249.588 211.281 254.029 202.124C258.248 193.17 260.932 186.088 262.204 180.957C262.245 180.455 262.312 179.971 262.372 179.541L262.389 179.417C262.45 178.981 262.507 178.568 262.555 178.121C262.529 177.176 262.427 176.42 262.205 175.593C261.777 173.994 261.02 173.006 259.76 172.278L259.735 172.264L259.71 172.249L245.76 163.83C241.245 161.221 237.372 158.361 234.388 155.329C231.15 152.227 228.918 148.588 227.841 144.567C226.98 141.356 226.905 137.728 227.428 134.075C227.911 130.295 228.962 126.265 230.647 121.816C230.649 121.812 230.65 121.809 230.651 121.806L251.403 65.87C253.183 60.9071 256.121 57.0067 259.763 53.9702C263.256 50.9775 267.454 48.8391 271.88 47.6533C283.41 44.5638 295.47 46.5341 307.646 53.4292C317.544 58.7706 325.502 65.637 331.577 73.8512C337.582 81.88 341.971 91.1152 344.683 101.236C348.812 116.646 349.558 133.658 347.004 152.227L347.002 152.236C344.417 170.595 339.253 189.752 331.789 209.477L331.786 209.485L331.783 209.493C324.183 229.234 314.942 248.632 304.063 267.685L304.06 267.691L304.056 267.698C300.447 273.949 296.654 280.094 292.677 286.133L291.122 288.495L288.672 287.081L229.039 252.652Z",
    stroke: "black",
    strokeWidth: 6
  }), /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter2_i_3834_20858)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M100.005 348.541C101.084 352.568 102.92 356.546 105.438 360.188C106.178 361.223 106.917 362.258 107.801 363.254C111.633 367.777 116.108 371.819 121.512 375.304C130.64 381.182 139.91 384.71 149.646 385.955C149.79 385.916 149.973 386.022 150.116 385.983C159.527 387.161 169.233 386.565 179.157 383.905C193.827 379.975 208.579 372.322 223.23 360.843C237.882 349.364 251.878 335.44 265.075 319.109C269.567 313.435 274.058 307.761 278.185 301.877L218.553 267.448C215.335 271.547 212.356 274.812 209.76 277.203C209.118 277.684 208.37 278.346 207.479 279.047C206.444 279.787 205.332 280.239 204.038 280.586C201.593 281.241 199.492 280.879 197.486 279.721L183.665 271.863C179.106 269.231 174.922 267.423 171.151 266.584C167.304 265.457 163.726 265.336 160.13 266.3C157.398 267.032 154.675 268.378 151.858 270.52C149.041 272.662 146.234 275.419 143.293 278.827L104.744 325.382C101.698 328.973 99.9185 332.686 99.2999 336.706C98.8251 340.687 98.9256 344.514 100.005 348.541Z",
    fill: "#FCFCFC"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M102.997 361.932L102.983 361.913L102.97 361.894C100.262 357.976 98.2772 353.685 97.1069 349.317C95.9089 344.846 95.8113 340.625 96.321 336.351L96.3271 336.3L96.3348 336.25C97.049 331.61 99.1018 327.4 102.444 323.455C102.448 323.45 102.452 323.446 102.456 323.441L140.983 276.914L141.002 276.89L141.022 276.867C144.05 273.357 147.008 270.439 150.042 268.132C153.127 265.787 156.197 264.248 159.354 263.402C163.513 262.287 167.624 262.44 171.9 263.677C176.045 264.615 180.488 266.566 185.156 269.26C185.159 269.262 185.162 269.263 185.165 269.265L198.968 277.113L198.977 277.118L198.986 277.123C200.34 277.905 201.626 278.127 203.261 277.688C204.303 277.409 205.041 277.092 205.683 276.643C206.038 276.362 206.371 276.087 206.708 275.808L206.8 275.732C207.129 275.459 207.483 275.166 207.832 274.9C210.257 272.653 213.091 269.548 216.193 265.596L217.8 263.549L220.053 264.85L279.685 299.279L282.523 300.917L280.641 303.599C276.464 309.555 271.928 315.286 267.454 320.938L267.427 320.971L267.418 320.983L267.409 320.994C254.084 337.483 239.929 351.571 225.08 363.205C210.171 374.886 195.061 382.75 179.933 386.803C169.726 389.538 159.716 390.175 150 388.992C149.97 388.991 149.941 388.99 149.913 388.989L149.852 389.006L149.266 388.931C139.036 387.623 129.347 383.917 119.888 377.826L119.886 377.825C114.23 374.178 109.541 369.944 105.533 365.219C104.555 364.112 103.745 362.979 103.031 361.98L102.997 361.932ZM149.266 388.905C149.266 388.905 149.267 388.906 149.269 388.906L149.266 388.905Z",
    stroke: "black",
    strokeWidth: 6
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M224.999 61.6728C221.031 59.9056 215.88 60.0075 210.681 61.9561C205.481 63.9047 200.658 67.5403 197.272 72.0632C193.887 76.5861 192.217 81.6257 192.629 86.0734C193.041 90.5212 195.502 94.0126 199.47 95.7798",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M221.817 35.6442C216.17 33.1294 208.085 34.2839 199.34 38.8538C190.596 43.4236 181.908 51.0345 175.188 60.012C168.469 68.9895 164.267 78.5983 163.509 86.7246C162.75 94.8509 165.496 100.829 171.143 103.344",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M217.994 11.081C211.395 8.14213 201.162 10.5396 189.547 17.7459C177.931 24.9522 165.884 36.377 156.056 49.5071C146.228 62.6372 139.424 76.397 137.141 87.7594C134.858 99.1218 137.283 107.156 143.882 110.095",
    stroke: "black",
    strokeWidth: 3,
    strokeLinecap: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3834_20858",
    x: -3.83203,
    y: 0.243652,
    width: 445.672,
    height: 445.669,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 4
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3834_20858"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3834_20858",
    result: "shape"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_i_3834_20858",
    x: 221.93,
    y: 43.2339,
    width: 129.551,
    height: 249.274,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3834_20858"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_i_3834_20858",
    x: 93.0312,
    y: 259.65,
    width: 193.828,
    height: 132.91,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 12,
    dy: 11
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_3834_20858"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhone2);
export default __webpack_public_path__ + "static/media/phone2.61a6e2c1202272f0cc5fde7ced7a8c44.svg";
export { ForwardRef as ReactComponent };